import {AuthError} from '@planday-corp/core/services/Auth';
import Service from '@planday-corp/core/services/Service';
import {AuthService} from '@planday-corp/core/services/protocols';

export class AnonymousAuth
  extends Service<undefined, undefined, 'authenticated'>
  implements AuthService
{
  static defaultSettings = {
    allowAnonymous: true,
  };

  async initialize() {
    this.rejectEvent(
      'authenticated',
      'Anonymous auth will never authenticate.'
    );
  }

  getUser(): never {
    throw AuthError.notAuthenticatedError();
  }

  getToken(): never {
    return this.getUser();
  }

  getSubjectId() {
    return this.getUser();
  }

  isAuthenticated() {
    return Promise.resolve(false);
  }

  signin() {
    return Promise.reject('Signin not possible for anonymous auth.');
  }

  signout() {
    return Promise.reject('Signout not possible for anonymous auth.');
  }
}
